<!-- <tt-dashboard-widget-base [(ttDashboardWidget)]="ttDashboardWidget" (ttDashboardWidgetChange)="mapGraphdata()"> -->
<ag-charts-angular *ngIf="graphoption" style="width: 100%; height: 100%" [options]="graphoption" (onChartReady)="onChartReady($event)"></ag-charts-angular>

<!-- <span class="tt-webpagemenu-dashboard-widget__value" [style.color]="ttDashboardWidget?.tile_heading_text_color">{{ ttDashboardWidget?.data1_text ?? "" }}</span> -->
<!-- </tt-dashboard-widget-base> -->
